import React, { useEffect, useRef, useState } from "react"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

import RrTable from "./RrTable"
import { moment } from "utils"
import { getOrders } from "services"
import RrHeader from "./RrHeader"
import RrExcelButton from "./RrExcelButton"
import { Navbar } from "components"
import classes from "./index.module.scss"

const limit = 30

const initialFiltersState = {
  branchId: "",
  isDispatched: true,
  account: null,
  addedByAccount: null,
  fromDate: "",
  toDate: "",
  fromDispatchedAt: "",
  toDispatchedAt: "",
  fromDeliveredAt: moment().startOf("day").toISOString(),
  toDeliveredAt: moment().endOf("day").toISOString()
}

const RepositoryReport = () => {
  const [t] = useTranslation()

  const history = useHistory()

  const [skip, setSkip] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [filter, setFilter] = useState(initialFiltersState)
  const [dispatchedOrders, setDispatchedOrders] = useState([])

  const unmount = useRef(false)

  const handleGoBack = () => {
    history.push("/settings")
  }

  const loadMore = async () => {
    try {
      const response =
        await getOrders({
          skip,
          limit,
          branchId: filter.branchId,
          fromDate: filter.fromDate,
          toDate: filter.toDate,
          fromDispatchedAt: filter.fromDispatchedAt,
          toDispatchedAt: filter.toDispatchedAt,
          fromDeliveredAt: filter.fromDeliveredAt,
          toDeliveredAt: filter.toDeliveredAt,
          sortBy: "newstOrder",
          statusMultiple: ["delivered"],
          isDispatched: filter.isDispatched,
          accountId: filter.account?.value,
          addedByAccountId: filter.addedByAccount?.value
        })

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setDispatchedOrders(prev => [...prev, ...response])
    } catch (err) {
      console.log(err)
    }
  }

  const getDispatchedOrders = async () => {
    setSkip(0)
    setHasMore(true)
    setDispatchedOrders([])

    try {
      const response =
        await getOrders({
          skip: 0,
          limit,
          branchId: filter.branchId,
          fromDate: filter.fromDate,
          toDate: filter.toDate,
          fromDispatchedAt: filter.fromDispatchedAt,
          toDispatchedAt: filter.toDispatchedAt,
          fromDeliveredAt: filter.fromDeliveredAt,
          toDeliveredAt: filter.toDeliveredAt,
          sortBy: "newstOrder",
          statusMultiple: ["delivered"],
          isDispatched: filter.isDispatched,
          accountId: filter.account?.value,
          addedByAccountId: filter.addedByAccount?.value
        })


      if (unmount.current) return

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setDispatchedOrders(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getDispatchedOrders()
  }, [filter])

  useEffect(() => {
    unmount.current = false

    return () => { unmount.current = true }
  }, [])

  return (
    <div className={classes["container"]}>
      <Navbar
        variant="compact"
        title={t("گزارش_انبارداری")}
        onLeftIconPress={handleGoBack}
      />

      <RrHeader
        filter={filter}
        setFilter={setFilter}
      />

      <RrExcelButton
        filter={filter}
      />

      <RrTable
        skip={skip}
        loadMore={loadMore}
        hasMore={hasMore}
        dispatchedOrders={dispatchedOrders}
      />
    </div>
  )
}

export default RepositoryReport